module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/heroFeatured2.webp";